import { createIrisApiClient, basePaths } from 'API/clients/iris/irisapi'
import { IrisRoutes } from 'API/definitions/iris/routes'
import { filterParamSerializer } from 'API/utilities/filterParamSerializer'

const irisApiClient = createIrisApiClient(basePaths.iris)

const summaryData = (params?) =>
  irisApiClient.get(IrisRoutes['ReviewSummary'], { params, paramsSerializer: filterParamSerializer })

export { summaryData }
